import { Navigate, useRoutes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { DevelopmentPage } from 'components/ErrorsPage/DevelopmentPage'

export const useBuildRoutes = () => {

  const { i18n:{language} } = useTranslation()
      
  return [
    {
      path: '/',
      element: <Navigate to={`/${language}/under-develop`} replace />
    },
    {
      path: `/${language}/under-develop`,
      element: <DevelopmentPage />
    },
  ]
}

export const Views = () => useRoutes( useBuildRoutes() )